import type { ISurveyReport } from '@/types/Data'
import type { IGetSurveyReport } from '@/types/Request'
import BaseService from '../BaseService'

export default class SurveyReportServices extends BaseService {
  GetSurveyReport(payload: IGetSurveyReport) {
    return this.POST<ISurveyReport>(this.PATHS.GET_SURVEY_REPORT, payload)
  }

  GetSurveyRepeatableReport(payload: IGetSurveyReport) {
    return this.POST<ISurveyReport>(this.PATHS.GET_SURVEY_REPEATABLE_REPORT, payload)
  }

  GetSurveyReportExcel(payload: IGetSurveyReport) {
    return this.EXCEL(this.PATHS.GET_SURVEY_REPORT, true, payload)
  }

  GetSurveyRepeatableReportExcel(payload: IGetSurveyReport) {
    return this.EXCEL(this.PATHS.GET_SURVEY_REPEATABLE_REPORT_EXCEL, false, payload)
  }

  GetSurveyAnswerByUserExcel(surveyId: string) {
    return this.EXCEL(this.PATHS.GET_SURVEY_ANSWER_BY_USER_EXCEL, true, { surveyId })
  }
}
